import errorApi from '../../api/errorApi';
import { getBaseUrl } from '../../constants';
import { decrypt } from '../../secure';
import { getXApiKeyByEnv } from '../../constants';

const withLoginDatalake = async ({
  customerId,
  APIPayloadToPost,
  Authorization,
}) => {
  const res = await errorApi(
    `${getBaseUrl()}dashboardmenus/datalake/tracking`,
    APIPayloadToPost,
    'POST',
    {
      Authorization: Authorization,
      'x-api-key': getXApiKeyByEnv(),
    }
  );
  console.log('datalake response', decrypt(customerId, res.data.response));
};

export default withLoginDatalake;
